import { render, staticRenderFns } from "./noFreeReadPopup3.vue?vue&type=template&id=5d4de605&scoped=true"
import script from "./noFreeReadPopup3.vue?vue&type=script&lang=js"
export * from "./noFreeReadPopup3.vue?vue&type=script&lang=js"
import style0 from "./noFreeReadPopup3.vue?vue&type=style&index=0&id=5d4de605&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4de605",
  null
  
)

export default component.exports